import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { NzMentionComponent } from 'ng-zorro-antd/mention';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'om-mention',
  templateUrl: './om-mention.component.html',
  styleUrls: ['./om-mention.component.scss']
})
export class OmMentionComponent implements OnInit {
  @Input() control: FormControl;
  @Input() suggestionKey: string;
  @Input() suggestions: Map<string, string[]>;
  _suggestions$: Observable<string[]>;
  @Input() text: string;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() notEmptyMentions = false;
  @Input() isValidFn: (val: string) => boolean = (val) => true;

  selectedMentions: string[] = [];

  @ViewChild('mentions', { static: true }) mentionChild!: NzMentionComponent;

  checkIfMentions(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const isValid = this.isValidFn(control.value);
      return isValid ? null : { emptyMentions: 'Should at least have one mention' };
    };
  }

  constructor() { }

  ngOnInit(): void {
    this.control = this.control ?? new FormControl('');
    if (this.notEmptyMentions) {
      this.control.addValidators(this.checkIfMentions());
    }
    this._suggestions$ = this.control.valueChanges.pipe(startWith(this.control.value)).pipe(
      map(_ => {
        const suggestions = this.suggestions.get(this.suggestionKey);
        if (!suggestions) return [];
        const mentions = this.mentionChild.getMentions();
        if (mentions.length === 0 || (mentions.length === 1 && !mentions[0]?.includes('.'))) return suggestions;
        const mentionsToCheck = mentions.filter((mention) => mention.includes('.'));
        const newSuggestions = suggestions.filter((suggestion) => !mentionsToCheck.includes('@' + suggestion));
        return newSuggestions;
      })
    );
  }

}
